// Whale-Alerts-Store — Ringbuffer der letzten N HL-Whale-Trades aus der WS.
// Wird befüllt vom AppShell-side-effect via useHyperliquidGlobal({ onWhaleTrade }).
// Konsumiert von right-rail/tab-whales.tsx.
//
// Pure in-memory, kein persist — Whales werden im Backend separat persistiert
// (hl_wallet_alerts für watched-wallets), das hier ist nur Live-Feed.

import { create } from 'zustand';
import type { WhaleAlert } from '@/types/hyperliquid';

const MAX_ALERTS = 50;

export interface WhaleAlertsState {
  alerts: ReadonlyArray<WhaleAlert>;
  push: (alert: WhaleAlert) => void;
  clear: () => void;
}

export const useWhaleAlertsStore = create<WhaleAlertsState>()((set) => ({
  alerts: [],
  push: (alert) =>
    set((state) => ({
      alerts: [alert, ...state.alerts].slice(0, MAX_ALERTS),
    })),
  clear: () => set({ alerts: [] }),
}));

export const selectWhaleAlerts = (s: WhaleAlertsState): ReadonlyArray<WhaleAlert> => s.alerts;
